import React from "react";
import { CIPPrediction, MembranePrediction } from "constants/constantStrings";
import PopoverText from "components/PopoverText";
import InfoIconGreen from "../../../assets/Other/info-icon-green.svg";

const customCCCellRenderer = params => {
  const ccValue = params.value;
  const cleaningValue = params.data?.proposedCleaning;
  const textColor = cleaningValue?.includes("-") ? "redText" : "greenText";
  return <div className={textColor}>{ccValue}</div>;
};

const customCleaningCellRenderer = params => {
  const cleaningValue = params.value;
  const textColor = cleaningValue?.includes("-") ? "redText" : "greenText";
  return <div className={textColor}>{cleaningValue}</div>;
};

const PREDICTION_TABLE_COLUMN = type => [
  {
    field: "variable",
    headerName: CIPPrediction.predictionVariable,
    editable: false,
    flex: 1,
    sortable: false
  },
  {
    field: "cc",
    headerName: CIPPrediction.predictionCC,
    editable: false,
    flex: 1,
    sortable: false,
    cellRenderer: customCCCellRenderer
  },
  {
    field: "proposedCleaning",
    headerName: type === "prediction" ? CIPPrediction.predictionCleaning : MembranePrediction.thresholdTime,
    editable: false,
    flex: 1,
    sortable: false,
    cellRenderer: customCleaningCellRenderer
  }
];
const customMembraneCellRenderer = params => {
  const value = params.data.variable;
  const isAdmin = params.isAdmin;
  const descriptionText = isAdmin ? MembranePrediction.conductivityPopovertextAdmin : MembranePrediction.conductivityPopovertext;
  if (value === "Permeate Conductivity(µS/cm)") {
    return (
      <div>
        {value}
        <PopoverText descriptor={<img src={InfoIconGreen} alt="icon" />} descriptionText={descriptionText} />
      </div>
    );
  }
  return <div>{value}</div>;
};

export const MEMBRANE_PREDICTION_TABLE_COLUMN = (type, isAdmin) => [
  {
    field: "variable",
    headerName: CIPPrediction.predictionVariable,
    editable: false,
    flex: 1,
    sortable: false,
    cellRenderer: params => customMembraneCellRenderer({ ...params, isAdmin }),
    minWidth: 250
  },
  {
    field: "threshold",
    headerName: CIPPrediction.threshold,
    editable: false,
    flex: 1,
    sortable: false
  },
  {
    field: "currentvalue",
    headerName: CIPPrediction.currentValue,
    editable: false,
    flex: 1,
    sortable: false
  },
  {
    field: "parentHeader",
    headerName: MembranePrediction.heading,
    editable: false,
    children: [
      {
        field: "cc",
        headerName: MembranePrediction.cc,
        editable: false,
        flex: 1,
        sortable: false,
        cellRenderer: customCCCellRenderer
      },
      {
        field: "proposedCleaning",
        headerName: type === "prediction" ? CIPPrediction.predictionCleaning : MembranePrediction.time,
        editable: false,
        flex: 1,
        sortable: false,
        cellRenderer: customCleaningCellRenderer
      }
    ]
  }
];

export const PREDICTION_TABLE_COLUMNS = type => PREDICTION_TABLE_COLUMN(type);
